import { TMS } from 'types/enums/Integrations';

import { LTLItem } from '../types';

export interface LTLStackabilityOptions {
  stackingEnabled: boolean;
  isItemStackable?: (item: LTLItem) => boolean;
}

export function isThreeGItemStackable(item: LTLItem): boolean {
  return !item.nonStackable;
}

export function resolveLTLStackabilityOptions({
  integrationName,
  stackingEnabled,
}: {
  integrationName?: TMS;
  stackingEnabled: boolean;
}): LTLStackabilityOptions {
  if (integrationName === TMS.ThreeG) {
    return {
      stackingEnabled: true,
      isItemStackable: isThreeGItemStackable,
    };
  }

  return {
    stackingEnabled,
  };
}
